<caremoni-dialog-template id="tag-info-dialog" [dialogTemplate]="dialogTemplate" (closeModalHandler)="closeModal()">
    <div modal-body>
        <div class="dialog-container">
            <div class="dialog-content">
                <p>
                    CAREKARTEのタグ機能は、記録を効率的に管理・検索するための仕組みです。
                </p>
                <p>
                    記録に#食事などのタグをつけると、タイトル名やIDが変わっても、#食事でまとめて表示できます。
                </p>
                <p>
                    タグを使うことで、タイトル名やIDの変更に影響されず、必要な情報を常に探し出せます。
                </p>
                <p>
                    各タイトルのタグ情報は、CAREKARTEのタイトルマスタから確認することができます。
                </p>
                <p class="pd-5 ml-5 mb-none">
                    タイトル
                </p>
                <div class="tag-info-1"></div>
                <p class="pd-5 ml-5 mb-none">
                    タイトル内の部品（項目）
                </p>
                <div class="tag-info-2"></div>
                <span class="ml-5 f-14">ケアモニ設定画面では#タイトル区分タグ.タイトルタグ.項目タグの順で#食事.おやつ.摂取量と表示します。</span>
                
            </div>
        </div>
    </div>
    <div modal-footer>
        <div class="dialog-footer">
            <div class="close-link" (click)="closeModal()">閉じる</div>
        </div>
    </div>
</caremoni-dialog-template>